<template>
  <div>
    <button class="btn btn-primary" @click="buttonClick">
      <span class="ml-2">Re-Send Incomplete Interviews</span>
    </button>
    <!-- Modal -->
    <div ref="modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5 class="modal-title text-capitalize">Re-Send Incomplete Interviews</h5>
            <button type="button" class="close" aria-label="Close" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ErrorSummary :error="error" />
            <div class="alert alert-warning text-small">
              <fa icon="exclamation-triangle" />
              Please note, by clicking continue, new emails for all interviews that have not been completed or declined ({{ this.countOfInterviews() }}) will be
              sent to interviewees.
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="resendIncompleteInterviews">Continue</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ErrorSummary from "@/components/ErrorSummary.vue";

export default {
  components: {
    ErrorSummary,
  },
  props: {
    isLoading: Boolean,
    investigation: Object,
    interviews: Array,
  },
  data() {
    return {
      successMessage: null,
      loadingMessage: null,
      error: null,
      isSendingAll: false,
    };
  },
  computed: {
    isSelfLoading() {
      return !!this.loadingMessage;
    },
  },
  methods: {
    buttonClick() {
      if (this.investigation.statusCode === "open") {
        this.showModal();
        return;
      }
    },
    showModal() {
      $(this.$refs.modal).modal("show");
    },
    closeModal() {
      $(this.$refs.modal).modal("hide");
    },
    countOfInterviews() {
      return this.interviews.filter(i => this.canResendInterview(i)).length;
    },
    reset() {
      this.loadingMessage = false;
      this.error = null;
      this.isSendingAll = false;
    },
    canResendInterview(interview) {
      return (
        this.investigation.statusCode === "open" &&
        interview.organizationReportId &&
        interview.organizationReportStatusCode !== "completed" &&
        interview.organizationReportStatusCode !== "declined" &&
        !interview.loadingMessage
      );
    },
    async resendIncompleteInterviews() {
      this.isSendingAll = true;
      await this.interviews
        .filter(i => this.canResendInterview(i))
        .reduce(async (promise, interview) => {
          await promise;
          await new Promise(r => setTimeout(r, 250));
          await this.sendInterview(interview, true);
        }, Promise.resolve())
        .then(() => {
          this.closeModal();
          this.$emit("reload");
          this.isSendingAll = false;
        });
    },
    async sendInterview(interview, suppressReload) {
      await this.$axios
        .post(
          `/v1/organizations/${this.investigation.organizationId}/investigations/${this.investigation.investigationId}/interviews/${interview.organizationInvestigationInterviewId}/send`
        )
        .catch(err => (this.error = err))
        .finally(() => {
          if (!suppressReload) this.$emit("reload");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

.modal,
.modal-content,
.modal-body {
  overflow: visible;
  overflow-y: visible;
}

.vc-popover-content-wrapper {
  z-index: 1080;
}
</style>
